import React, { useEffect, useState } from "react";
import { FiMessageSquare } from "react-icons/fi";
import HistoricoAmbiente, { BalaoComentarios } from "../../components/HistoricoAmbiente";
import SlideOverPanel from "../../components/SlideOverPanel";
import { formatarData, formatarMoeda } from "../../utils/calculos";
import { getColunasMaquinas } from "../../utils/industrializacao";
import { getAmbienteTone } from "./dominio";
import {
  AmbienteCard,
  AmbienteCardTopo,
  AmbienteDatasGrid,
  AmbienteNome,
  AmbientesLista,
  BotaoHistorico,
  Chip,
  ChipRow,
  DatoCampo,
  DatoLabel,
  DatoValor,
  ModalInfoCard,
  ModalInfoGrid,
  ModalInfoLabel,
  ModalInfoValue,
  StatusBadge,
} from "./styles";

// F9 (2026-05-29): modal antigo substituido por SlideOverPanel
// (mesmo painel deslizante usado nas demais paginas).
// O lote junta vários ambientes; o histórico é POR AMBIENTE — cada cartão
// abre o seu (um aberto por vez, para o painel não virar um mural).
export default function LoteDrawer({ lote, precosVisiveis, onClose }) {
  const [historicoAberto, setHistoricoAberto] = useState(null);
  useEffect(() => {
    setHistoricoAberto(null);
  }, [lote?.id]);

  return (
    <SlideOverPanel
      open={!!lote}
      onClose={onClose}
      title={lote?.loteLabel}
      subtitle={
        lote
          ? `${lote.clientes.join(", ")} — ${lote.totalAmbientes} ambientes no lote • ${lote.totalPendentes} pendentes nas máquinas`
          : undefined
      }
      width="min(94vw, 720px)"
    >
      {lote && (
        <>
          <ModalInfoGrid>
            <ModalInfoCard>
              <ModalInfoLabel>Data de Otimização</ModalInfoLabel>
              <ModalInfoValue>{lote.dataOtimizacao}</ModalInfoValue>
            </ModalInfoCard>
            <ModalInfoCard>
              <ModalInfoLabel>Chegada do MDF/Bordo</ModalInfoLabel>
              <ModalInfoValue>{lote.dataMdf}</ModalInfoValue>
            </ModalInfoCard>
            <ModalInfoCard>
              <ModalInfoLabel>Limite das Máquinas</ModalInfoLabel>
              <ModalInfoValue>{formatarData(lote.dataLimiteMaquinas)}</ModalInfoValue>
            </ModalInfoCard>
            <ModalInfoCard>
              <ModalInfoLabel>Entrega do Contrato</ModalInfoLabel>
              <ModalInfoValue>{formatarData(lote.entregaContrato)}</ModalInfoValue>
            </ModalInfoCard>
            {getColunasMaquinas().map((operacao) => (
              <ModalInfoCard key={operacao.chave}>
                <ModalInfoLabel>{operacao.titulo}</ModalInfoLabel>
                <ModalInfoValue>{lote.datasPorOperacao[operacao.chave]}</ModalInfoValue>
              </ModalInfoCard>
            ))}
            <ModalInfoCard>
              <ModalInfoLabel>Valor do Lote</ModalInfoLabel>
              <ModalInfoValue>
                {precosVisiveis ? formatarMoeda(lote.valorTotal) : "••••••"}
              </ModalInfoValue>
            </ModalInfoCard>
          </ModalInfoGrid>

          <ChipRow>
            <Chip $tone={lote.statusVariant}>{lote.status}</Chip>
            {getColunasMaquinas().map((operacao) => (
              <Chip key={operacao.chave}>
                {lote.aguardandoPorOperacao[operacao.chave]} aguardando{" "}
                {operacao.titulo.toLowerCase()}
              </Chip>
            ))}
          </ChipRow>

          <AmbientesLista>
            {lote.ambientes.map((ambiente, index) => (
              <AmbienteCard key={`${lote.id}-${ambiente.ambiente}-${index}`}>
                <AmbienteCardTopo>
                  <AmbienteNome title={ambiente.ambiente}>
                    {ambiente.ambiente}
                    <BalaoComentarios row={ambiente.row} />
                  </AmbienteNome>
                  <StatusBadge $tone={getAmbienteTone(ambiente)}>{ambiente.status}</StatusBadge>
                </AmbienteCardTopo>
                <AmbienteDatasGrid>
                  <DatoCampo>
                    <DatoLabel>Limite Máquinas</DatoLabel>
                    <DatoValor $muted={!ambiente.pendente}>
                      {formatarData(ambiente.dataLimite)}
                    </DatoValor>
                  </DatoCampo>
                  <DatoCampo>
                    <DatoLabel>Entrega Prevista</DatoLabel>
                    <DatoValor>{formatarData(ambiente.entregaContrato)}</DatoValor>
                  </DatoCampo>
                  <DatoCampo>
                    <DatoLabel>MDF/Bordo</DatoLabel>
                    <DatoValor>{formatarData(ambiente.mdfBordo)}</DatoValor>
                  </DatoCampo>
                  {getColunasMaquinas().map((operacao) => (
                    <DatoCampo key={operacao.chave}>
                      <DatoLabel>{operacao.titulo}</DatoLabel>
                      <DatoValor>{formatarData(ambiente.datas[operacao.chave])}</DatoValor>
                    </DatoCampo>
                  ))}
                </AmbienteDatasGrid>
                <BotaoHistorico
                  type="button"
                  aria-expanded={historicoAberto === index}
                  onClick={() => setHistoricoAberto((atual) => (atual === index ? null : index))}
                >
                  <FiMessageSquare size={13} aria-hidden="true" />
                  {historicoAberto === index ? "Fechar histórico" : "Histórico e comentários"}
                </BotaoHistorico>
                {historicoAberto === index && <HistoricoAmbiente row={ambiente.row} />}
              </AmbienteCard>
            ))}
          </AmbientesLista>
        </>
      )}
    </SlideOverPanel>
  );
}
